// extracted by mini-css-extract-plugin
export default {"chart_container":"CustomPieChart_chart_container__q8zF6","legend_container":"CustomPieChart_legend_container__gCfos","legend":"CustomPieChart_legend__gGVaz"};